
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};
Greenmile.PanelBuilder.SelectFieldList = function (lookUpEntity) {

    this.lookUpEntity = lookUpEntity;

    this.fieldList = {};
    this.elFieldList = document.createElement('div');
    this.elFieldList.className = 'MonetUIFilterBuilderSelectContainer ' + this.lookUpEntity;
    this.clickListeners = [];
    this.beforeCreateList = null;

    this.addClickEventListener = function (callback) {
        this.clickListeners.push(callback);
    };

    this.notifyClickEvent = function (field) {
        for (var i = 0, length = this.clickListeners.length; i < length; i++) {
            this.clickListeners[i](field);
        }
    };

    this.getValue = function () {
        return this.value;
    };

    this.getSelectedField = function () {
        return this.value;
    };

    this.setSelectedField = function (field) {
        this.value = field;
        var selectPicker = $(this.elFieldList.querySelector('select.pickListFieldFilters'));
        selectPicker.selectpicker('val', field.name);
        selectPicker.selectpicker('refresh');
        this.notifyClickEvent(field);
    };

    this.setFieldList = function (fieldList) {
        this.fieldList = fieldList;
    };

    this.createOptionField = function (field) {
        var option = document.createElement('option');
        var fieldType = field.type;
        option.value = field.name;
        option.setAttribute('value', field.name);

        option.setAttribute('name', field.name);
        option.setAttribute('label', field.translatedLabel);
        option.setAttribute('type', fieldType);
        option.innerHTML = field.translatedLabel;
        return option;
    };

    this.renderFieldList = function () {

        var fragment = document.createDocumentFragment();
        var select = document.createElement('select');
        select.className = 'pickListFieldFilters fieldList';
        select.setAttribute('data-live-search', 'true');
        select.setAttribute('data-max-options', '1');
        select.setAttribute('mutiple', 'true');
        select.setAttribute('title', Monet.I18n.getResourcesByKey('Fields.NoSelected'));

        select.appendChild(this.createOptionField({ name: " ", translatedLabel: " " }));

        for (var field in this.fieldList) {
            select.appendChild(this.createOptionField(this.fieldList[field]));
        }
        fragment.appendChild(select);

        return fragment;

    };

    this.createList = function () {

        if (this.beforeCreateList) {
            this.beforeCreateList(this.fieldList);
        }

        this.elFieldList.appendChild(this.renderFieldList());

        var pickList = $(this.elFieldList.querySelector('.pickListFieldFilters'));

        pickList.selectpicker({
            size: 10,
            callback: function (val) {
                var field = this.fieldList[val];
                if (field) {
                    this.value = field;
                } else {
                    this.value = '';
                }
                this.notifyClickEvent(field, this.value);
            }.bind(this),
            entity: this.lookUpEntity,
            liveSearchNormalize: true
        });

        pickList.selectpicker('refresh');
        pickList.selectpicker('show');
    };

    this.reduceToFieldTypes = function (typesToReturn) {

        for (var key in this.fieldList) {
            if (typesToReturn.indexOf(this.fieldList[key].type) === -1) {
                delete this.fieldList[key];
            }
        }
    };

    this.populateFieldList = function () {
        var fields = (App.Forms[this.lookUpEntity] ? App.Forms[this.lookUpEntity].fields : null);
        this.fieldList = JSON.parse(JSON.stringify(fields));
    };

    this.render = function () {

        this.populateFieldList();

        if (!this.fieldList) {

            var dataMapper = new Monet.Builder.DataMapper();
            dataMapper.setEntity(this.lookUpEntity);
            dataMapper.getFieldList(function () {
                this.populateFieldList();
                this.createList();
            }.bind(this));

        } else {
            this.createList();
        }

        return this.elFieldList;

    };

};